require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww.json") })
        }
      }, "path---news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww!./.cache/json/news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww!./.cache/json/news-c-6-wf-ccbn-yi-6-gy-zvq-dcuu-c-ww.json
// module chunks = 231608221292675